import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DashboardService } from '../../services/dashboard.service';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-branding',
  templateUrl: './branding.component.html',
  styleUrls: ['./branding.component.scss']
})
export class BrandingComponent implements OnInit {

  isLoading = true;

  loggedInUserDetails;

  getPartnerDetailsPostData = {
    section: '101'
  };

  displayImageUrl;
  brandingForm: FormGroup;

  color_1: string;
  color_2: string;

  originalPrimaryColor = '#007fb6';
  originalSecondaryColor = '#ea6915';
  // logoImagePath: string;

  isLargeImage = false;
  uploadedImageName = '';

  saveBtnLabel = 'Saved';

  constructor(private formBuilder: FormBuilder, private dashboardService: DashboardService) {

    // this.dashboardService.setSidebarFlag();

  }

  ngOnInit() {
    this.color_1 = '#007fb6';
    this.color_2 = '#ea6915';

    this.brandingForm = this.formBuilder.group({
      type: ['changes'],
      image: [''],
      primary_color: [''],
      secondary_color: ['']
    });

    this.dashboardService.getPartnerData(this.getPartnerDetailsPostData).subscribe(response => {
      this.isLoading = false;
      // this.brandingForm.patchValue({
      //   primary_color: response.data.primary_color,
      //   secondary_color: response.data.secondary_color,
      // });
      this.color_1 = response.data.primary_color;
      this.color_2 = response.data.secondary_color;
      this.displayImageUrl = environment.logo_baseUrl + this.loggedInUserDetails.partner_id + '/' + response.data.image;
    });

    this.loggedInUserDetails = this.dashboardService.decodeToken();
  }

  uploadImage(event) {
    if (event.target.files[0].size > 500000) {
      this.isLargeImage = true;
    }
    else {
      this.saveBtnLabel = 'Save Changes';

      this.isLargeImage = false;

      const uploadData = new FormData();
      uploadData.append('image', event.target.files[0]);
      uploadData.append('partner_id', this.loggedInUserDetails.partner_id);

      this.dashboardService.uploadImage(uploadData).subscribe(data => {
        this.uploadedImageName = data.name;
        this.displayImageUrl = environment.logo_baseUrl + this.loggedInUserDetails.partner_id + '/' + this.uploadedImageName;
      });
    }
  }

  brandingFormSubmit() {
    this.saveBtnLabel = 'Saving...';

    this.brandingForm.patchValue({
      primary_color: this.color_1,
      secondary_color: this.color_2,
      image: this.uploadedImageName
    });

    this.dashboardService.setBrandingDetails(this.brandingForm.value).subscribe(data => {
      if (data.statusCode == 500 && data.status == false) {

      }
      else {
        this.saveBtnLabel = 'Saved';
      }
    });
  }

  revertToOriginal() {
    this.resetFlag();

    this.color_1 = this.originalPrimaryColor;
    this.color_2 = this.originalSecondaryColor;

    this.brandingForm.patchValue({
      primary_color: this.color_1,
      secondary_color: this.color_2
    });
  }

  resetFlag() {
    this.saveBtnLabel = 'Save Changes';
  }

}
